module.exports = __webpack_public_path__ + "static/media/gallery-22.fba1db89.jpg";